import { NetworkRequest } from "./NetworkRequest";
import { NetworkService } from "./NetworkService";
import Swal from 'sweetalert2';

export default class SubmitDataService {
  static async submitUsageData(data) {
    return NetworkService.request({
      alias: NetworkRequest.UsageData,
      url: "dimensionamento/utilizacao",
      method: "POST",
      data: data
    }).then(() => {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Dados salvos com sucesso!",
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true
      }).then(() => {
        window.location.reload();
      });
    })
      .catch((error) => {
        console.log(error);
      });
  }

  static async getUsageData() {
    return NetworkService.request({
      alias: NetworkRequest.UsageData,
      url: "dimensionamento/utilizacao",
      method: "GET",
    })
      .catch((error) => {
        console.log(error);
      });
  }
}